// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f5c44d4","453":"5859d6e7","499":"90eb6c44","667":"e274028c","915":"48369e69","977":"791ceac8"}[chunkId] + ".chunk.js";
};